export const duckName = 'filters'
